import Modal from "@shared/v2/Modal";
import Loading from "../Loader";
import { useWizardContext } from "./WizardContext";

const CalculatingGoals = () => {
  const { year, goToPage } = useWizardContext();

  return (
    <>
      <Modal.Header title={`Calculating Your ${year} Goals...`} />
      <Modal.Body className="tw-relative tw-h-[50px]">
        <Loading />
      </Modal.Body>
      <Modal.Footer className="tw-text-center tw-text-gray-50" onClick={() => goToPage(3)}>
        Goals are being generated...
      </Modal.Footer>
    </>
  );
};

export default CalculatingGoals;
